import { useState, useEffect } from "react";

const useIsMobile = (minWidth: number): boolean => {
  const [isSmall, setIsSmall] = useState(() => window.innerWidth < minWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsSmall(window.innerWidth < minWidth);
    };

    window.addEventListener("resize", handleResize);

    // Initial check in case screen size changed before hook mounted
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [minWidth]);

  return isSmall;
};

export default useIsMobile;
